/**
 * Valid search field names 'magic' link search.
 * Ticket: #23707
 */
export const VALID_SEARCH_FIELDS = new Set([
	'email1', 'email2',
	'urn1', 'urn2', 'urn3',
	'custom1', 'custom2', 'custom3', 'custom4', 'custom5',
	'custom6', 'custom7', 'custom8', 'custom9', 'custom10'
])
